export var StudentDetailAssignmentStatusEnum;
(function (StudentDetailAssignmentStatusEnum) {
    StudentDetailAssignmentStatusEnum["NOT_STARTED"] = "NOT_STARTED";
    StudentDetailAssignmentStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    StudentDetailAssignmentStatusEnum["COMPLETED"] = "COMPLETED";
})(StudentDetailAssignmentStatusEnum || (StudentDetailAssignmentStatusEnum = {}));
export var GradeType;
(function (GradeType) {
    GradeType["PASS_FAIL"] = "PASS_FAIL";
    GradeType["SCORED"] = "SCORED";
    GradeType["UPGRADED"] = "UPGRADED";
    GradeType["MASTERY"] = "MASTERY";
    GradeType["NOT_GRADED"] = "NOT_GRADED";
})(GradeType || (GradeType = {}));
export var ASSIGNMENT_SCORING_TYPE_MAPPING = Object.freeze({
    PASS_FAIL: 'Pass/Fail',
    NOT_GRADED: 'Not Graded',
    SCORED: 'Scored'
});
export var ASSIGNMENT_TYPE_MAPPING = Object.freeze({
    MASTERY: 'EAQ Mastery',
    STANDARD: 'EAQ Custom Quiz',
    QUIZ_BY_QUESTION: 'EAQ Custom Quiz by Question',
    AUTHESS: 'AUTHESS',
    CHART: 'CHART'
});
